var _path, _path2, _path3, _rect, _text, _circle, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkCsvDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "download-svg",
    width: 160,
    height: 160,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2H15L19 6V17",
    stroke: "#94a3b8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5H12L16 9V20C16 21.1046 15.1046 22 14 22H6C4.89543 22 4 21.1046 4 20V5Z",
    fill: "white",
    stroke: "#545899",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5V9H16",
    stroke: "#545899",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 14,
    width: 8,
    height: 4,
    rx: 1,
    fill: "#545899"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 17.2,
    fontFamily: "sans-serif",
    fontSize: 2.5,
    fontWeight: "bold",
    fill: "white",
    textAnchor: "middle"
  }, "CSV")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 14,
    r: 5,
    fill: "white",
    stroke: "#545899",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12V16M18 16L16 14M18 16L20 14",
    stroke: "#545899",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkCsvDownload);
export default __webpack_public_path__ + "static/media/bulk-csv-download.1518b56c3db6a1436f169fa229da86da.svg";
export { ForwardRef as ReactComponent };